import { reactive, readonly } from "vue";
import axios from "axios";
import router from "@/router";
import { locale } from "element-plus";
import de from "element-plus/lib/locale/lang/de";
import "dayjs/locale/de";
import en from "element-plus/lib/locale/lang/en";
import "dayjs/locale/en";

const state = reactive({
  isAuthenticated: false,
  language: "de",
  isLoading: false,
  customer_name: "",
  login_type: "",
  provider_module: false,
  noticesfield: false,
  deleteentries: false,
  csrftoken: ""
});

const methods = {
  setLoading: function(bool) {
    state.isLoading = bool;
  },
  setLogin: function(bool) {
    state.isAuthenticated = bool;
  },
  setCSRFToken: function(strings) {
    state.csrftoken = strings;
    localStorage.setItem("csfrtoken", strings);
  },
  getCSRFToken: function() {
    if (state.csrftoken == "") {
      return localStorage.getItem("csfrtoken", "");
    } else {
      return state.csrftoken;
    }
  },
  setCustomerName: function(name) {
    state.customer_name = name;
  },
  setLoginType: function(type) {
    state.login_type = type;
  },
  setProviderModule: function(bool) {
    state.provider_module = bool;
  },
  setNoticesField: function(bool) {
    state.noticesfield = bool;
  },
  setDeleteEntries: function(bool) {
    state.deleteentries = bool;
  },
  setLogout: function() {
    state.isAuthenticated = false;
    state.provider_module = false;
    state.noticesfield = false;
    state.deleteentries = false;
    state.isLoading = false;
  },
  switchLanguage: function(lang) {
    state.language = lang;

    if (lang == "de") {
      locale(de);
    } else {
      locale(en);
    }
  },
  async apiRequest(command, fields) {
    state.isLoading = true;
    const params = fields ?? {};
    let json = { command: command, csrftoken: methods.getCSRFToken() };

    if (Object.keys(params).length > 0) {
      json.parameters = params;
    }

    var data = new FormData();

    data.append("request", JSON.stringify(json));

    axios.defaults.withCredentials = true;

    const response = await axios
      .post(process.env.VUE_APP_API_PATH, data, {
        headers: { "Content-Type": "multipart/form-data" }
      })
      .then(resp => {
        methods.setLoading(false);

        if (
          resp.data.errordetails &&
          (resp.data.errordetails == "unrecognized_request :login" ||
            resp.data.errordetails == "login_needed")
        ) {
          methods.setLoading(false);
          methods.setLogin(false);

          if (router.currentRoute._value.name != "users") router.push("/login");
        } else {
          return resp;
        }
      })
      .finally(() => {
        methods.setLoading(false);
      });

    return response;
  }
};

export default {
  state: readonly(state),
  methods
};
